import ReportesRoutes from './reportes';
import AdministrationRoutes from './administracion';

export default [].concat(
    ReportesRoutes,
    AdministrationRoutes,
);